import React from "react";
import { Image } from "../../components/componentIndex";

const DropdownList = ({Icon, item, index}) => {
    return (
        <a key={index} className="dropdown-item" href="#">
            <Image imgUrl={Icon} altText={'insurance'} className={'insurance-icon'} /> <span>{item.name}</span>
        </a>
    )
};

export default DropdownList;